// extracted by mini-css-extract-plugin
module.exports = {"tokens":"InvestUnitSmall_tokens__vGa7Q","tokenLogo":"InvestUnitSmall_tokenLogo__HIfhc"};